module.exports = __webpack_public_path__ + "img/latest_news_banner.42a95255.webp";